// import external modules
import React, { Component } from "react";

import {
   Home,
   ChevronRight,
   List,
   FilePlus,
   Grid,
   Book,
   Settings,
   Briefcase,
   BookOpen,
   Layers
} from "react-feather";
import { NavLink } from "react-router-dom";

// Styling
import "../../../../assets/scss/components/sidebar/sidemenu/sidemenu.scss";
// import internal(own) modules
import SideMenu from "../sidemenuHelper";
import { css  } from "@emotion/core";
import BarLoader from 'react-spinners/BarLoader';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  height:3px;
`;

class SideMenuContent extends Component {

   render() {

     if(this.props.loadingMenu){

      return (
         <SideMenu className="sidebar-content" Category={this.props.Category} toggleSidebarMenu={this.props.toggleSidebarMenu}>
            <SideMenu.MenuSingleItem permission={9}>
            <div style={{width:'100%',height:50,justifyContent:'center'}}>
            <BarLoader
               sizeUnit={"px"}
               size={3}
               color={'#ffffff'}
               loading={true}
               css={override}
            />
         </div>
         </SideMenu.MenuSingleItem>
         </SideMenu>
      );
     }else{
        //console.log(this.props.toggleSidebarMenu);
      return (
         <SideMenu className="sidebar-content" Category={this.props.Category} toggleSidebarMenu={this.props.toggleSidebarMenu}>
            <SideMenu.MenuSingleItem permission={9}>
               <NavLink to="/dashboard"  activeClassName="active">
                  <i className="menu-icon">
                  <Home size={18} />
                  </i>
                  <span className="menu-item-text">Dashboard</span>
               </NavLink>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem permission={3}>
               <NavLink to="/planning"  activeClassName="active">
                  <i className="menu-icon">
                  <Layers size={18} />
                  </i>
                  <span className="menu-item-text">Planificación</span>
               </NavLink>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem permission={5}>
               <NavLink to="/status"  activeClassName="active">
                  <i className="menu-icon">
                     <FilePlus size={18} />
                  </i>
                  <span className="menu-item-text">Status</span>
               </NavLink>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem permission={3}>
               <NavLink to="/tablecontrol" activeClassName="active">
                  <i className="menu-icon">
                     <Grid size={18} />
                  </i>
                  <span className="menu-item-text">Tablero</span>
               </NavLink>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem permission={3}>
               <NavLink to="/company"  activeClassName="active">
                  <i className="menu-icon">
                     <Briefcase size={18} />
                  </i>
                  <span className="menu-item-text">Empresas</span>
               </NavLink>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuSingleItem permission={5}>
               <NavLink to="/training"  activeClassName="active">
                  <i className="menu-icon">
                     <BookOpen size={18} />
                  </i>
                  <span className="menu-item-text">Capacitaciones</span>
               </NavLink>
            </SideMenu.MenuSingleItem>
            <SideMenu.MenuMultiItems permission={1}
               name="Tareas"
               Icon={<List size={18} />}
               ArrowRight={<ChevronRight size={16} />}
               collapsedSidebar={this.props.collapsedSidebar}
               >
               <NavLink to="/task" exact className="item" activeclassname="active">
                  <span className="menu-item-text">Listar</span>
               </NavLink>
               <NavLink to="/detour" exact className="item" activeclassname="active">
                  <span className="menu-item-text">Desvíos</span>
               </NavLink>
            </SideMenu.MenuMultiItems>
            <SideMenu.MenuSingleItem permission={5}>
               <NavLink to="/notice"  activeClassName="active">
                  <i className="menu-icon">
                  <Book size={18} />
                  </i>
                  <span className="menu-item-text">Circulares</span>
               </NavLink>
            </SideMenu.MenuSingleItem>

            <SideMenu.MenuMultiItems permission={1} 
               name="Sistema"
               Icon={<Settings size={18} />}
               ArrowRight={<ChevronRight size={16} />}
               collapsedSidebar={this.props.collapsedSidebar}>
               <NavLink to="/users" exact className="item" activeclassname="active">
                  <span className="menu-item-text">Usuarios</span>
               </NavLink>
            </SideMenu.MenuMultiItems>
         </SideMenu>
      );
     }
     
      
   }
}

export default SideMenuContent;
/*
SideMenuContent.propTypes = {
   UserCategory: PropTypes.number
 };

const mapStateToProps = state => ({
   UserCategory: state.auth.category
 });
 const mapDispatchToProps = {
    // GetVehicles
 };
 export default connect(
   mapStateToProps,
   mapDispatchToProps
   )(SideMenuContent);*/
